module.exports = __webpack_public_path__ + "img/ClickHereIcon.c528423c.svg";